export const MONTHS_AF = ['حمل','ثور','جوزا','سرطان','اسد','سنبله','میزان','عقرب','قوس','جدی','دلو','حوت'];
export const DAYS_SHORT = ['ش','ی','د','س','چ','پ','ج'];

// Gregorian → Jalali
export function toJalali(gy, gm, gd) {
  let g_y = gy - 1600, g_m = gm - 1, g_d = gd - 1;
  let g_day_no = 365*g_y + Math.floor((g_y+3)/4) - Math.floor((g_y+99)/100) + Math.floor((g_y+399)/400);
  const g_dm = [31,28+(g_y%4===0&&(g_y%100!==0||g_y%400===0)?1:0),31,30,31,30,31,31,30,31,30,31];
  for (let i=0; i<g_m; i++) g_day_no += g_dm[i];
  g_day_no += g_d;
  let j_day_no = g_day_no - 79;
  let j_np = Math.floor(j_day_no/12053); j_day_no %= 12053;
  let jy = 979 + 33*j_np + 4*Math.floor(j_day_no/1461); j_day_no %= 1461;
  if (j_day_no >= 366) { jy += Math.floor((j_day_no-1)/365); j_day_no = (j_day_no-1)%365; }
  let i;
  for (i=0; i<11 && j_day_no>=(i<6?31:30); i++) j_day_no -= (i<6?31:30);
  return [jy, i+1, j_day_no+1];
}

// Jalali → Gregorian  ← FIXED ALGORITHM
export function toGregorian(jy, jm, jd) {
  let jy2 = jy - 979, jm2 = jm - 1, jd2 = jd - 1;
  let j_day_no = 365*jy2 + Math.floor(jy2/33)*8 + Math.floor((jy2%33+3)/4);
  for (let i=0; i<jm2; i++) j_day_no += i < 6 ? 31 : 30;
  j_day_no += jd2;
  let g_day_no = j_day_no + 79;
  let gy = 1600 + 400*Math.floor(g_day_no/146097);
  g_day_no = g_day_no % 146097;
  let leap = true;
  if (g_day_no >= 36525) {
    g_day_no--;
    gy += 100*Math.floor(g_day_no/36524);
    g_day_no = g_day_no % 36524;
    if (g_day_no >= 365) g_day_no++;
    else leap = false;
  }
  gy += 4*Math.floor(g_day_no/1461);
  g_day_no %= 1461;
  if (g_day_no >= 366) { leap = false; g_day_no--; gy += Math.floor(g_day_no/365); g_day_no = g_day_no % 365; }
  const g_dm = [31, leap?29:28, 31,30,31,30,31,31,30,31,30,31];
  let gm = 0;
  for (gm=0; gm<12; gm++) { if (g_day_no < g_dm[gm]) break; g_day_no -= g_dm[gm]; }
  return [gy, gm+1, g_day_no+1];
}

export function daysInMonth(jy, jm) {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  return [1,5,9,13,17,22,26,30].includes(jy%33) ? 30 : 29;
}

export function todayJalali() {
  const d = new Date();
  return toJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

export function isoToAfghan(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  const [jy,jm,jd] = toJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
  return `${jy}/${String(jm).padStart(2,'0')}/${String(jd).padStart(2,'0')}`;
}

export function isoToAfghanFull(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  const [jy,jm,jd] = toJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
  return `${jd} ${MONTHS_AF[jm-1]} ${jy}`;
}

export function fmtNum(n) {
  if (n===undefined||n===null) return '—';
  return new Intl.NumberFormat('en-US').format(n);
}

export function fmtAFN(n, cur='AFN') {
  if (n===undefined||n===null) return '—';
  return `${new Intl.NumberFormat('en-US').format(n)} ${cur==='AFN'?'AFN':'$'}`;
}
